import { createSelector } from '@reduxjs/toolkit';

export const selectFormValues = (state) => state.payment.form;
export const selectFormRestored = (state) => state.payment.form.restored;
export const selectData = (state) => state.payment.data;
export const selectError = (state) => state.payment.error;
export const selectLoading = (state) => state.payment.loading;
export const selectRestored = (state) => state.payment.restored;

export const selectProductCodes = createSelector([selectData], (data) =>
  data?.products?.map(({ code }) => code?.code)
);
